// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Tpx9","question":"styles_question__EA1-W","description":"styles_description__3-szl"};